export default "__VITE_ASSET__DqLIjO67__"